import React from 'react';
import { motion } from 'framer-motion';
export function Reviews() {
  const reviews = [{
    text: 'Nunca pensé que iba a poder hablarle a mi vecino sordo. En dos semanas ya nos saludamos y charlamos básico. Increíble.',
    author: 'María G.',
    location: 'Córdoba'
  }, {
    text: 'Mi hija tiene una compañera sorda. Este material me permitió acompañarla de verdad. Vale cada peso.',
    author: 'Laura P.',
    location: 'Rosario'
  }, {
    text: 'Entró un cliente sordo a la farmacia. Por primera vez pude atenderlo sin papel y lapicera. Se emocionó. Yo también.',
    author: 'Roberto M.',
    location: 'Buenos Aires'
  }];
  return <section className="bg-white text-lsa-dark py-12 px-5" data-id="element-271">
      <div className="max-w-xl mx-auto" data-id="element-272">
        <h2 className="text-xl font-bold text-center mb-8" data-id="element-273">
          Lo que dicen quienes ya lo tienen
        </h2>

        <div className="flex flex-col gap-4" data-id="element-274">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-lsa-light p-5 rounded-2xl border border-lsa-celeste/20 shadow-sm" data-id="element-275">
              <div className="text-lsa-celeste mb-2 text-lg tracking-widest" data-id="element-276">
                ★★★★★
              </div>
              <p className="italic text-[15px] leading-relaxed mb-4 text-lsa-dark/90" data-id="element-277">
                "{review.text}"
              </p>
              <div className="text-sm font-semibold text-lsa-dark" data-id="element-278">
                — {review.author}{' '}
                <span className="text-lsa-dark/50 font-normal" data-id="element-279">
                  · {review.location}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}